/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * IndexService is responsible for making Index page api calls and model level calculations
 *
 * @module enervee_utils.index
 */

IndexService.$inject = [
    '$q',
    '$sce',
    '$log',
    '$state',
    '$filter',
    '$timeout',
    '$rootScope',
    'AccountAuthService',
    'ProductApiConsumerService',
    'CmsContentService',
    'FavProductsService',
    'ModalQueueService',
    'ModalService',
    'SignupService',
    'SwiftypeService',
    'UtilService'
];
function IndexService (
    $q,
    $sce,
    $log,
    $state,
    $filter,
    $timeout,
    $rootScope,
    AccountAuthService,
    ProductApiConsumerService,
    CmsContentService,
    FavProductsService,
    ModalQueueService,
    ModalService,
    SignupService,
    SwiftypeService,
    UtilService
) {
    var _pub = {};
    var _indexProductsData = {};
    var _specifiedIndexProductsData = {};
    var _signupModalHeader = '';
    var _signupModalSubheader = '';
    var _signupModalFilters = []
    var _onProductPageLoadedCallBacks = [];
    var _onIndexPageLoadedCallBacks = [];
    var _onCategoryPageLoadedCallBacks = [];
    var _currentRebate = null;
    var _delayedTransition = null;
    var _replaceCartInfo = {}

    _pub.isSolarRatesEnabled = UtilService.isFeatureEnabled('solar_rates');

    /*
    Used to prevent alerts from showing up in different application state.
    Place on top of the controller where header alerts are used.
     */
    _pub.clearHeaderAlerts = function () {
        $rootScope.$root.alerts = null;
    };

    /**
     * Used to set header alerts from anyplace the service is injected.
     * @param {Array<Object>} alerts
     * @param {string} alerts[].type
     * @param {string} alerts[].message
     * @param {Boolean} [doReload=false]
     */
    _pub.setHeaderAlerts = function (alerts, doReload) {
        $rootScope.$root.alerts = alerts;

        if (doReload) {
            $timeout(function () {
                $state.reload();
            }, 3000);
        } else {
            // Clears alerts after a short time
            $timeout(_pub.clearHeaderAlerts, 4000);
        }
    };

    /*
    Fetches index page's products and other product related data based on the given category id, if supplied.
    */
    _pub.fetchIndexProductsData = function (categoryId) {
        if (categoryId === null){
            return ProductApiConsumerService.get('api/1.0/product-sections/').then(function (response) {
                _indexProductsData = response.data;
            });
        }
        return ProductApiConsumerService.get('api/1.0/product-sections/' + categoryId + '/').then(function (response) {
            _indexProductsData = response.data;
        });
    };

    /*
    Return index's product data
     */
    _pub.getIndexProductsData = function () {
        return _indexProductsData;
    };

    /**
     * Fetches random product sections for the index page (used for the category-less index page)
     */
    _pub.fetchSpecifiedIndexProductsData = function (names) {
        return ProductApiConsumerService.request({
            method: 'GET',
            url: 'api/1.0/specified-product-sections/',
            params: {
                "names": JSON.stringify(names)
            }
        }).then(function (response) {
            // Order the sections according to the name list
            var productSections = response.data;
            var compareFunction = function (a, b) {
                var indexA = names.indexOf(a.section_title),
                    indexB = names.indexOf(b.section_title);
                if (indexA < indexB) {
                    return -1;
                } else if (indexA === indexB) {
                    return 0;
                } else {
                    return 1;
                }
            };
            productSections.sort(compareFunction);
            _specifiedIndexProductsData = productSections;
        });
    };

    /**
     * It gets category names and returns a promise which will be resolved after all product sections are
     * retrieved from swiftype passes the product sections into the callback attached to it.
     * @param categoryNames
     */
    _pub.getProductSections = function (categoryNames) {

        var defer = $q.defer();
        var indexProductSectionSettings = UtilService.getSiteSetting("index_product_sections");
        var numberOfResolvedRequests = 0;
        var retrievedProductSections = [];

        angular.forEach(indexProductSectionSettings, function (productSectionSetting, key) {
            var searchParams = {
                q: productSectionSetting.q,
                document_types: productSectionSetting.document_types,
                per_page: productSectionSetting.per_page,
                sort_field: productSectionSetting.sort_field,
                filters: productSectionSetting.filters,
                sort_direction: productSectionSetting.sort_direction
            };

            SwiftypeService.getResults(searchParams).then(function (data) {

                var products = data.records[productSectionSetting.category_code] || [];
                retrievedProductSections.push(
                    {
                        title: productSectionSetting.title,
                        view_all_link_text: productSectionSetting.view_all_link_text,
                        ordering: productSectionSetting.ordering,
                        products: products,
                        category_code: productSectionSetting.category_code,
                        section_order: productSectionSetting.section_order,
                        filters: productSectionSetting.url_filters
                    }
                );
                numberOfResolvedRequests++;

                // When the last response was received we will resolve this promise
                if (numberOfResolvedRequests === indexProductSectionSettings.length) {

                    retrievedProductSections = $filter('orderBy')(retrievedProductSections, 'section_order');

                    defer.resolve(retrievedProductSections);
                }

            }, function (result) {
                $log.error('Product section (' + productSectionSetting.title + ') could not be retrieved from swiftype!');
                defer.reject({redirectTo: '404'});
            });
        });

        return defer.promise;
    };


    /**
     * Return the random product sections retrieved by fetchRandomIndexProductsData
     */
    _pub.getSpecifiedIndexProductsData = function () {
        return _specifiedIndexProductsData;
    };

    /**
     * Hides the current modal and displays another one
     * @param currentModal
     * @param modalNewId
     */
    _pub.switchModal = function (currentModalId, newModalId) {
        var modalNew = $(newModalId);

        _pub.closeModal(currentModalId);
        _pub.openModal(newModalId);

        modalNew.on('hidden.bs.modal', function () {
            // Remove duplicate padding
            $('body').css({'padding-right': 0});
        });
    };

    /**
     * Hides the current modal
     * @param currentModalId
     */
    _pub.closeModal = function (currentModalId) {
        var modalCurrent = $(currentModalId);
        modalCurrent.modal('hide');
        ModalService.setModalIsClosed(currentModalId);
    };

    /**
     * Opens a modal
     * @param modalId id of the modal
     * @param options can include {backdrop: "static"}
     */
    _pub.openModal = function (modalId, options) {

        if (ModalService.currentModals[modalId] && ModalService.currentModals[modalId].isOpen) {
            return;
        }

        ModalQueueService.closePastModals(function () {
            _pub.closeModal(modalId);
        });

        var modal = $(modalId);

        if (options) {
            modal.modal(options);
        } else {
            modal.modal('show');
        }
        ModalService.setModalIsOpen(modalId, 'div[ui-view]');
        modal.on('hide.bs.modal', function () {
            ModalService.setModalIsClosed(modalId);
        });
    };

    /**
     * Remove modal restrictions e.g. modal not dismissible
     * by hitting the esc key or clicking outside the modal
     * @param modalId
     */
    _pub.resetModalOptions = function (modalId) {
        var modal = $(modalId);
        if ('data' in modal && 'bs.modal' in modal.data()) {
            modal.data('bs.modal').options.backdrop = true;
            modal.data('bs.modal').options.keyboard = true;
        }
    };

    /**
     * Calls the event when the modal is closed
     *
     * @param modalId
     * @param event
     */
    _pub.onModalClosed = function (modalId, event) {
        var modal = $(modalId);

        modal.off('hidden.bs.modal');
        modal.on('hidden.bs.modal', function (e) {
            event();
        });
    };

    /**
     * Helper function to reset a field who's `$error` attr
     * has been manually set to true.
     */
    _pub.resetFormField = function (formField) {
        formField.invalid = false;
        if ('message' in formField) {
            // Removes custom backend error messages
            formField.message = null;
        }
    };

    /**
     * Helper function to help validate and input form field.
     *
     * @param inputFormField e.g. createPasswordForm.newPassword
     */
    _pub.validateFormField = function (inputFormField) {
        var fieldName = $("input[name='" + inputFormField.$name + "']");

        if (inputFormField.$valid === true) {
            // success - field is valid, remove the error class
            fieldName.removeClass('ng-invalid');
        } else if ( inputFormField.$valid === false) {
            // error - add the error
            fieldName.addClass('ng-invalid');
        }
    };

    _pub.getSignupModalSubheader = function () {
        return _signupModalSubheader;
    };

    _pub.getSignupModalHeader = function () {
        return _signupModalHeader;
    };


    _pub.setSignupModalHeaders = function (header_code, context = {}) {
        var fav;
        // CMS Text Keys
        var _favProductHeader = 'base:modals:add_to_favorites_header_text';
        var _favProductSubHeader = 'base:modals:add_to_favorites_sub_header_text';
        var _saveYourSeachHeader ='base:modals:save_your_search_header_text';
        var _saveYourSeachSubHeader ='base:modals:save_your_search_sub_header_text';
        var _saveYourMileageHeader ='base:modals:save_your_mileage_header_text';
        var _saveYourMileageSubHeader ='base:modals:save_your_mileage_sub_header_text';
        var _signInOrRegister = 'base:modals:sign_in_or_register_text';

        switch (header_code) {
            case 'fav_product':
                CmsContentService.getMarketPlaceText(_favProductHeader).then(function (text) {
                    _signupModalHeader = text;
                });
                CmsContentService.getMarketPlaceText(_favProductSubHeader, context).then(function (text) {
                    _signupModalSubheader = $sce.trustAsHtml(text);
                });
                break;

            case 'save_search':
                CmsContentService.getMarketPlaceText(_saveYourSeachHeader).then(function (text) {
                    _signupModalHeader = text;
                });
                CmsContentService.getMarketPlaceText(_saveYourSeachSubHeader, context).then(function (text) {
                    _signupModalSubheader = $sce.trustAsHtml(text);
                });
                break;

            case 'save_mileage':
                CmsContentService.getMarketPlaceText(_saveYourMileageHeader).then(function (text) {
                    _signupModalHeader = text;
                });
                CmsContentService.getMarketPlaceText(_saveYourMileageSubHeader).then(function (text) {
                    _signupModalSubheader = $sce.trustAsHtml(text);
                });
                break;

            case 'save_product':
                _signupModalHeader = "Don't miss out on price drops!";
                _signupModalSubheader = $sce.trustAsHtml("Click the <i class='mp mp-bell-o'></i> to favorite products and get price drop updates in your inbox.");
                break;
            case 'saved_searches':
                _signupModalHeader = "Don't miss new models & price drops!";
                _signupModalSubheader = $sce.trustAsHtml(_signInOrRegister);
                break;
            default:
                CmsContentService.getMarketPlaceText(_signInOrRegister).then(function (text) {
                    _signupModalHeader = text;
                });
                _signupModalSubheader = '';
                break;
        }
    };

    _pub.getSignupModalFilters = function () {
        return _signupModalFilters;
    }

    _pub.setSignupModalFilters = function (filters = []) {
        _signupModalFilters = filters;
    }

    /**
     * Returns true if a productId is in the favoriteProductsIds list.
     * @param productId
     * @param favoriteProductsIds
     * @returns {boolean}
     */
    _pub.isProductFavored = function (productId, favoriteProductsIds, force) {
        var deferred = $q.defer();
        if (favoriteProductsIds && !force) {
            deferred.resolve(favoriteProductsIds.indexOf(productId) !== -1);
        } else {
            FavProductsService.fetchFavoriteProductsIdList(force).then(function (favProductIds) {
                var favProducts = favProductIds.filter(function(favProduct){ return favProduct.id === productId; });
                deferred.resolve(favProducts.length > 0);
            }, function () {
                IndexService.setHeaderAlerts([{
                    type: 'error',
                    message: 'Failed to load favorite products.',
                }]);
            });
        }
        return deferred.promise;
    };

    /**
     * calls the event on product page loaded
     * @param event
     */
    _pub.onProductPageLoaded = function (event) {

        _onProductPageLoadedCallBacks.push(event);

    };

    /**
     * Executes all product page loaded event callbacks
     */
    _pub.executeOnProductPageLoaded = function () {

        _onProductPageLoadedCallBacks.forEach(function (callback) {
            callback();
        });

        _onProductPageLoadedCallBacks = [];
    };

    /**
     * calls the event on index page loaded
     * @param event
     */
    _pub.onIndexPageLoaded = function (event) {

        _onIndexPageLoadedCallBacks.push(event);

    };

    /**
     * Executes all index page loaded event callbacks
     */
    _pub.executeOnIndexPageLoaded = function () {

        _onIndexPageLoadedCallBacks.forEach(function (callback) {
            callback();
        });

        _onIndexPageLoadedCallBacks = [];
    };

    /**
     * calls the event on index page loaded
     * @param event
     */
    _pub.onCategoryPageLoaded = function (event) {

        _onCategoryPageLoadedCallBacks.push(event);

    };

    /**
     * Executes all index page loaded event callbacks
     */
    _pub.executeCategoryPageLoaded = function () {

        _onCategoryPageLoadedCallBacks.forEach(function (callback) {
            callback();
        });

        _onCategoryPageLoadedCallBacks = [];
    };

    _pub.setRebateDisplay = function (rebate) {
        _currentRebate = rebate;
    };

    _pub.getRebateDisplay = function () {
        return _currentRebate;
    };

    /**
     * Takes state.go event and delays until a confirm modal is interacted with.
     * @param event
     * @param to
     * @param toParams
     */
    _pub.delayTransition = function (event, to, toParams) {
        event.preventDefault();
        _delayedTransition = {
            to: to,
            toParams: toParams
        };
    };

    /**
     * Cancels the current transition.
     */
    _pub.cancelTransition = function () {
        _delayedTransition = null;
    };

    /**
     * Continues the current transition.
     */
    _pub.continueTransition = function () {
        $state.go(_delayedTransition.to, _delayedTransition.toParams).then(function () {
            _delayedTransition = null;
        });
    };

    _pub.setReplaceCartInfo = function (data) {
        _replaceCartInfo = data;
    };

    _pub.getReplaceCartInfo = function () {
        return _replaceCartInfo;
    };

    /**
     * Calls functions required to set up and open the sign up modals.
     *
     * @param {string} nextUrl - page to redirect to after sign in.
     */
    _pub.signIn = function (nextUrl) {
        SignupService.setNextUrl(nextUrl);
        _pub.setSignupModalHeaders();
        SignupService.signUpModalOpenedCallBack();
        _pub.openModal('#modal-enter-email');
        AccountAuthService.onEveryAuthChange("resetNextUrl", function() {
            SignupService.setNextUrl(null);
        });
    };

    /**
     * Initiates the sign in service, using the provided email address as the
     * required address for the authentication process. If an invalid email address
     * is provided, then no specific email address will be required of the user.
     * @param {string} emailAddress - User's email address.
     * @param {string} nextUrl - Page to redirect to after sign in.
     */
    _pub.signInUserWithRequiredEmail = function (emailAddress, nextUrl) {
        return $q(resolve => {
            SignupService.setRequiredEmail(emailAddress);
            _pub.signIn(nextUrl);
            // If the user sign in is successful, the promise should resolve successfully.
            AccountAuthService.onAuthChange(resolve);
            // Regardless of when the user logs in, after logging in, the
            // required email value must be reset to `null`.
            AccountAuthService.onEveryAuthChange("resetRequiredEmail", function() {
                SignupService.setRequiredEmail(null);
            });
        });
    };

    return _pub;
}

module.exports = IndexService;
